import { Decorative } from "@faire/design-tokens";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { SDUIComponentInstanceRendererProps } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUIButtonRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";
import { SDUIRichTextRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/RichText/SDUIRichTextRenderer";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { IButtonElement } from "@faire/web-api--source/indigofair/data/IButtonElement";
import React from "react";

export const SDUISiteBannerRenderer: React.FC<
  SDUIComponentInstanceRendererProps
> = ({ component, loggingData }) => {
  const { isMobile } = useViewport();
  const siteBannerComponent = component.site_banner_component;

  if (!siteBannerComponent) {
    return null;
  }

  const { description } = siteBannerComponent;
  const mobileValue = description?.mobile_and_above;
  const tabletValue = description?.tablet_and_above ?? mobileValue;
  const desktopAndAboveValue = description?.desktop_and_above ?? tabletValue;
  const backgroundColor = siteBannerComponent.style?.background_color
    ? getSlateColorToken(siteBannerComponent.style?.background_color)
    : Decorative.tint.neutral;

  return (
    <div
      className={`relative flex w-screen items-center justify-center px-6 py-2 ${isMobile ? "flex-col" : "flex-row"}`}
      style={{
        backgroundColor,
      }}
      data-test-id="site-banner-renderer"
    >
      <ResponsiveContentV2
        noJS
        mobile={<SDUIRichTextRenderer richTextElement={mobileValue} />}
        tablet={<SDUIRichTextRenderer richTextElement={tabletValue} />}
        desktopAndAbove={
          <SDUIRichTextRenderer richTextElement={desktopAndAboveValue} />
        }
      />
      {!isMobile ? <>&nbsp;</> : null}
      {siteBannerComponent.button ? (
        <SDUIButtonRenderer
          buttonElement={{
            ...siteBannerComponent.button,
            variant:
              siteBannerComponent.button.variant ??
              IButtonElement.ButtonVariant.TERTIARY,
          }}
          loggingData={loggingData}
        />
      ) : null}
    </div>
  );
};
